/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useRef, useState } from "react";
// react-router components
import { Route, Routes, useLocation } from "react-router-dom";

// Soft UI Dashboard PRO React routes
import routes from "routes";

//Components
import { createContext } from "react";
import { pathElements } from "./routes/pathElements";
import ReactQuerryWrapper from "./routes/reactqueryWrapper";
// FIREBASE DISABLED
// import { performance } from "./firebase";
// import { trace } from "firebase/performance";
import { holdCartList } from "./config/Services";
import { setHoldOrdersCount } from "./layouts/ecommerce/product/all-products/redux/Actions/holdOrdersCountActions";
import { useDispatch } from "react-redux";
import { Account } from "./layouts/ecommerce/product/settings/components/Account";
import { PrinterAgentProvider } from "./context/PrinterAgentContext";
import { SubscriptionProvider } from "./context/SubscriptionContext";
import { refreshRbacConfig } from "./services/rbacConfig";
import PrivateRoute from "./components/PrivateRoute";
import SubscriptionGateOverlay from "./components/SubscriptionGate";
import { KitchenNotificationsProvider } from "./context/KitchenNotificationsContext";

export const UserContext = createContext();
export default function App() {
  const { pathname } = useLocation();
  const [color, setColor] = useState("light");
  const [cartItems, setCartItems] = useState([]);
  const [cartId, setCartId] = useState(() => {
    const raw = localStorage.getItem("CartId");
    // Guard against objects/undefined getting coerced into the string "[object Object]"
    if (!raw || raw === "[object Object]" || raw === "undefined" || raw === "null") {
      if (raw) localStorage.removeItem("CartId");
      return null;
    }
    return raw;
  });
  const [total, setTotal] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [cgst, setCgst] = useState(0);
  const [sgst, setSgst] = useState(0);
  const [cess, setCess] = useState(0);
  const [totalTaxes, setTotalTaxes] = useState(0);
  const [loyaltyPoints, setLoyaltyPoints] = useState("");
  const [cartCoupon, setCartcoupon] = useState({});
  const [particularCategoryItems, setparticularCategoryItems] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("CASH");
  const [categoryName, setCategoryName] = useState("");
  const [removed, setRemoved] = useState(false);
  const [animationBox, setanimationBox] = useState(false);
  const [gtinItem, setItemgtin] = useState("");
  const [tableArrowActive, setTableActive] = useState(false);
  const [openModalTwoway, setOpenModalTwoway] = useState(false);
  const [totalAmountDen, setTotalamountDen] = useState(0);
  const [denoArr, setDenoArr] = useState([]);
  const [highlightMrp, setHighlightMrp] = useState("");
  const [offerCheckList, setOfferCheckList] = useState([]);
  const [openOffer, setOpenOffer] = useState(false);
  const [cusNum, setCusNum] = useState(false);
  const [cartTotalQty, setCartTotalQty] = useState("");
  const [couponApplied, setCouponApplied] = useState("0");
  const [offerFound, setOfferFound] = useState(false);
  const [searchText, setSearchText] = useState(null);
  const [saleMode, setSaleMode] = useState(() => {
    const saved = localStorage.getItem("saleMode");
    if (saved) return saved;
    const retailType = localStorage.getItem("retailType");
    return retailType === "RESTAURANT" ? "DINE_IN" : "in-store";
  });
  const [tableSelectionModalOpen, setTableSelectionModalOpen] = useState(() => {
    const branchSubType = localStorage.getItem("branchSubType");
    if (branchSubType === "FINE_DINE") {
      return true;
    } else {
      return false;
    }
  });
  const [selectedTable, setSelectedTable] = useState(() => {
    try {
      const stored = localStorage.getItem("selectedTableData");
      return stored ? JSON.parse(stored) : {};
    } catch {
      return {};
    }
  });
  const [menuAvailabilityOpen, setMenuAvailabilityOpen] = useState(false);
  const [tableLayoutRefetch, setTableLayoutRefetch] = useState(null);
  const [tableLayoutStats, setTableLayoutStats] = useState(null);
  const [cartRefetch, setCartRefetch] = useState(null);
  const [cartGrossBarVisible, setCartGrossBarVisible] = useState(false);
  const [customerActionButton, setCustomerActionButton] = useState("");
  const [customerMobileNumber, setCustomerMobileNumber] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [isLoadingScreen, setIsLoadingScreen] = useState(false);
  const [hasShownUpdatePopup, setHasShownUpdatePopup] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [highlightedCartProductId, setHighlightedCartProductId] = useState(null);
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails"));
  const uidx = retailUserDetails?.uidx;
  const locId = localStorage.getItem("locId");
  const dispatch = useDispatch();
  const appConfig = JSON.parse(localStorage.getItem("appConfig"));
  const holdCartVisibility = appConfig?.enabledFeatures?.HOLD_CART_VISIBLE;
  const terminalName = localStorage.getItem("licenseName");

  // for setting screen UI to render component
  const [activeTabComp, setActiveTabComp] = useState(<Account />);
  const [activeIndex, setActiveIndex] = useState(0);

  const firstTimeSearchRef = useRef(false);
  const pageNoRef = useRef(1);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);

  // Initialise RBAC config on mount
  useEffect(() => {
    refreshRbacConfig();
  }, []);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  useEffect(() => {
    if (saleMode) localStorage.setItem("saleMode", saleMode);
  }, [saleMode]);

  useEffect(() => {
    if (uidx && locId) holdOrderDataFun();
  }, [uidx, locId]);

  // ── Dual Screen sync — write cart state to localStorage so the customer
  // display tab can always read it, regardless of which component is mounted.
  // Skip this on the /dual-screen route itself: that tab has an empty cart
  // (it's just the display) and would overwrite the POS tab's data.
  useEffect(() => {
    if (pathname === "/dual-screen") return;
    try {
      const payload = {
        type: "cart_update",
        items: (cartItems || []).map((item) => ({
          name: item.productName || item.name || "",
          qty: item.quantity || 1,
          price: item.sellingPrice || 0,
          total: (item.sellingPrice || 0) * (item.quantity || 1),
        })),
        subtotal: subTotal || 0,
        tax: totalTaxes || 0,
        total: total || 0,
        discount: 0,
        customerName: customerName || "",
        customerMobile: customerMobileNumber || "",
      };
      localStorage.setItem("dualScreenCart", JSON.stringify(payload));
    } catch (_) {}
  }, [pathname, cartItems, total, subTotal, totalTaxes, customerName, customerMobileNumber]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={<PrivateRoute>{route.component}</PrivateRoute>}
            key={route.key}
          />
        );
      }
      return null;
    });

  //It monitor the initial page load time of app --> to trace the time taken for the main app to load
  // FIREBASE DISABLED - Commented out performance tracing
  // useEffect(() => {
  //   const loadTrace = trace(performance, `pos_app_load${location.pathname}`);
  //   loadTrace.start();

  //   // callback function to call when event triggers
  //   const onPageLoad = () => {
  //     loadTrace.stop();
  //   };

  //   // Check if the page has already loaded
  //   if (document.readyState === "complete") {
  //     onPageLoad();
  //   } else {
  //     window.addEventListener("load", onPageLoad, false);
  //     // Remove the event listener when component unmounts
  //     return () => window.removeEventListener("load", onPageLoad);
  //   }
  // }, [location.pathname]);

  const holdOrderDataFun = () => {
    // let holdOrderPayload = {
    //   sourceLocationId: locId,
    //   destinationId: locId,
    //   loggedInUser: uidx,
    // };
    let holdOrderPayload = {
      locationId: [locId],
      cartStatus: ["HOLD"],
      ...(!holdCartVisibility ? { terminalName: [terminalName] } : {}),
    };

    holdCartList(holdOrderPayload).then((res) => {
      if (res?.status === 200 && res?.data?.status === "SUCCESS") {
        let dataArr = res?.data?.data?.results;
        dispatch(setHoldOrdersCount(dataArr.length));
      }
    });
  };

  return (
    <ReactQuerryWrapper>
      <PrinterAgentProvider>
        <SubscriptionProvider>
          <KitchenNotificationsProvider>
          <UserContext.Provider
            value={{
              color,
              setColor,
              particularCategoryItems,
              setparticularCategoryItems,
              cartItems,
              setCartItems,
              cartId,
              setCartId,
              total,
              setTotal,
              subTotal,
              setSubTotal,
              totalValue,
              setTotalValue,
              sgst,
              setSgst,
              cgst,
              setCgst,
              paymentMethod,
              setPaymentMethod,
              categoryName,
              setCategoryName,
              setLoyaltyPoints,
              loyaltyPoints,
              setCartcoupon,
              cartCoupon,
              setRemoved,
              removed,
              setanimationBox,
              animationBox,
              gtinItem,
              setItemgtin,
              setTableActive,
              tableArrowActive,
              setOpenModalTwoway,
              openModalTwoway,
              totalAmountDen,
              setTotalamountDen,
              denoArr,
              setDenoArr,
              highlightMrp,
              setHighlightMrp,
              setOfferCheckList,
              offerCheckList,
              openOffer,
              setOpenOffer,
              setCusNum,
              cusNum,
              setCartTotalQty,
              cartTotalQty,
              setCouponApplied,
              couponApplied,
              searchText,
              setSearchText,
              setOfferFound,
              offerFound,
              setSaleMode,
              saleMode,
              setCess,
              cess,
              isLoadingScreen,
              setIsLoadingScreen,
              hasShownUpdatePopup,
              setHasShownUpdatePopup,
              totalTaxes,
              setTotalTaxes,
              searchActive,
              setSearchActive,
              activeTabComp,
              setActiveTabComp,
              activeIndex,
              setActiveIndex,
              firstTimeSearchRef,
              hasMore,
              setHasMore,
              page,
              setPage,
              selectedTable,
              setSelectedTable,
              customerActionButton,
              setCustomerActionButton,
              customerMobileNumber,
              setCustomerMobileNumber,
              customerName,
              setCustomerName,
              tableSelectionModalOpen,
              setTableSelectionModalOpen,
              menuAvailabilityOpen,
              setMenuAvailabilityOpen,
              tableLayoutRefetch,
              setTableLayoutRefetch,
              tableLayoutStats,
              setTableLayoutStats,
              cartRefetch,
              setCartRefetch,
              cartGrossBarVisible,
              setCartGrossBarVisible,
              highlightedCartProductId,
              setHighlightedCartProductId,
            }}
          >
            <Routes>
              {getRoutes(routes)}
              {pathElements.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={<PrivateRoute>{route.element}</PrivateRoute>}
                  exact={route.exact}
                />
              ))}
            </Routes>
            <SubscriptionGateOverlay />
          </UserContext.Provider>
          </KitchenNotificationsProvider>
        </SubscriptionProvider>
      </PrinterAgentProvider>
    </ReactQuerryWrapper>
  );
}
